import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { useIdHash } from '../hooks/custom.hooks';
// import { MOCK_ALL_OFFERS,MOCK_MERCHANT_OFFERS } from './mock.data';

const API_ENDPOINT = window.location?.hostname?.includes('offers.twidpay.com')
  ? 'https://mapi.twidpay.com'
  : 'https://mapi.beta.twidapp.com';

export function useAllOffers() {
  const { custId, hash, isApp } = useIdHash();

  return useQuery(
    ['allOffers'],
    async () => {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('customer-id', custId);
      myHeaders.append('offer-customer-hash', custId);
      if (isApp) {
        myHeaders.append('customer-hash', hash);
      }

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        mode: 'cors',
      };
      const result = await fetch(
        `${API_ENDPOINT}/mobile/v1/offer/all`,
        requestOptions,
      );
      // console.log(result,"resultkline");
      // return MOCK_ALL_OFFERS;
      return result.json();
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
    },
  );
}

export function useMerchantList() {
  // const { custId,hash,isApp } = useIdHash();

  return useQuery(
    ['merchantList'],
    async () => {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      // myHeaders.append('customer-id', custId);
      // myHeaders.append('offer-customer-hash', custId);
      // if (isApp) {
      //   myHeaders.append('customer-hash', hash);
      // }

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        mode: 'cors',
      };
      const result = await fetch(
        `${API_ENDPOINT}/mobile/v1/merchant/listing`,
        requestOptions,
      );
      // console.log(requestOptions,"resultkline");
      // return MOCK_MERCHANT_LISTING;
      return result.json();
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
    },
  );
}

const normalize = (value) => {
  if (value === 0 || value === 'null' || value === null) return null;
  if (value === 'undefined') return undefined;
  return value;
};

export function useOfferDetails() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramsObject = Object.fromEntries(searchParams.entries());
  const { t = '', vid = '', rdid = '', vcdi = '' } = paramsObject;
  const { custId, hash, isApp } = useIdHash();

  return useQuery(
    ['offerDetail'],
    async () => {
      const myHeaders = new Headers();
      myHeaders.append('content-type', 'application/json');
      myHeaders.append('customer-id', custId);
      myHeaders.append('offer-customer-hash', custId);
      if (isApp) {
        myHeaders.append('customer-hash', hash);
      }

      const raw = JSON.stringify({
        offer_id: normalize(vcdi),
        voucher_id: normalize(vid),
        type: normalize(t),
        reward_details_id: normalize(rdid),
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      const result = await fetch(
        `${API_ENDPOINT}/mobile/v1/offer/detail`,
        requestOptions,
      );
      return result.json();
    },
    {
      refetchOnWindowFocus: false,
    },
  );
}

export function useAppOffers() {
  const { custId, hash, isApp, app_version, os, version } = useIdHash();

  return useQuery(
    ['appOffers'],
    async () => {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('customer-hash', hash);
      myHeaders.append('app_version', app_version);
      myHeaders.append('os', os);
      myHeaders.append('version', version);
      myHeaders.append('customer-id', custId);

      if (isApp) {
        myHeaders.append('customer-hash', hash);
      }
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        mode: 'cors',
      };
      const result = await fetch(
        `${API_ENDPOINT}/mobile/v1/home/app-offers`,
        requestOptions,
      );
      // console.log(requestOptions,"resultLine");
      // return MOCK_MERCHANT_FEATURES_OFFERS;
      return result.json();
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
    },
  );
}
